import type { HTMLAttributes } from "react";
import { cn } from "../../lib/cn";

export type KbdProps = HTMLAttributes<HTMLElement>;

/** Tecla de atalho (`⌘`, `K`, `g`). Só exibição — quem escuta o teclado é a tela. */
export function Kbd({ className, ...props }: KbdProps) {
  return (
    <kbd
      className={cn(
        "inline-flex h-5 min-w-5 items-center justify-center rounded-sm border border-border",
        "bg-surface-subtle px-1 font-mono text-2xs text-muted-foreground",
        className,
      )}
      {...props}
    />
  );
}
